import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class IpService {
  private localIp: string | null = null;

  async loadLocalIp(): Promise<void> {
    try {
      this.localIp = await this.getLocalIp();
    } catch (error) {
      console.error('Failed to get local IP:', error);
      this.localIp = 'unknown';
    }
  }

  getIp(): string | null {
    return this.localIp;
  }

  private async getLocalIp(): Promise<string> {
    return new Promise((resolve, reject) => {
      if (typeof window === 'undefined' || typeof window.RTCPeerConnection === 'undefined') {
        reject(new Error('RTCPeerConnection is not available in this environment'));
        return;
      }
      const pc = new RTCPeerConnection({ iceServers: [] });
      pc.addEventListener('icecandidate', (event) => {
        if (!event.candidate) {
          // All candidates have been gathered
          reject(new Error('No ICE candidates found'));
          return;
        }
        if (event.candidate.candidate.indexOf('srflx') !== -1) {
          // Skip server reflexive candidates
          return;
        }
        const candidate = event.candidate.candidate;
        const regex = /([0-9]{1,3}(\.[0-9]{1,3}){3})/;
        const match = candidate.match(regex);
        if (match) {
          resolve(match[1]);
          pc.close();
        }
      });
      pc.createDataChannel('');
      pc.createOffer()
        .then(offer => pc.setLocalDescription(offer))
        .catch(reject);
    });
  }
}
